import React, { useMemo } from 'react';
import SimpleModal from 'ui/Modals/SimpleModal';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { ColDef } from 'ag-grid-community';
import HrDataGrid from 'routes/HumanResourcesModule/components/HrDataGrid/HrDataGrid';
import TextFloatingFilter from 'ui/AgGridReact/TextFloatingFilter';
import NumberFloatingFilter from 'ui/AgGridReact/NumberFloatingFilter';
import ChipCellRenderer from 'ui/AgGridReact/CellRenderers/ChipCellRenderer';
import { useTranslation } from 'react-i18next';
import { useGetHrSimulationEchelonsHypotheses } from '../../helpers/hooks/echelons';
import GridEchelonsCellRenderer from '../GridEchelons/GridEchelonsCellRenderer';
import { getColDefs } from './colDefinitions';

type Props = {
    hrSimulation: HrSimulation;
    showModal: boolean;
    setShowModal: (arg: boolean) => void;
};

export default function EchelonsHypothesesModal({
    hrSimulation,
    showModal,
    setShowModal,
}: Props) {
    const { t } = useTranslation();
    const {
        data: echelonHypothesesData,
        isLoading: isEchelonHypothesesDataLoading,
    } = useGetHrSimulationEchelonsHypotheses(hrSimulation.id);

    const echelonHypotheses = echelonHypothesesData || [];

    const columnDefs: ColDef[] = useMemo(() => getColDefs(t), []);

    return (
        <SimpleModal
            open={showModal}
            onClose={() => setShowModal(false)}
            maxWidth="xl"
        >
            <HrDataGrid
                title={t('humanResources.simulation.echelonsHypothesis')}
                rowData={echelonHypotheses}
                columnDefs={columnDefs}
                isLoading={isEchelonHypothesesDataLoading}
                exportFileName={`avancees_echelons_${hrSimulation.title}`}
                showTotal={false}
                hasFullScreenMode={false}
                gridProps={{
                    components: {
                        textFloatingFilter: TextFloatingFilter,
                        numberFloatingFilter: NumberFloatingFilter,
                        chipCellRenderer: ChipCellRenderer,
                        gridEchelonsCellRenderer: GridEchelonsCellRenderer,
                    },
                    rowGroupPanelShow: 'never',
                    pagination: false,
                    alwaysShowVerticalScroll: true,
                    suppressScrollOnNewData: false,
                }}
                sx={{
                    maxHeight: '600px',
                    '& .ag-body-viewport': {
                        overflowY: 'auto',
                        maxHeight: '500px',
                    },
                    '& .ag-body-vertical-scroll': {
                        maxHeight: '500px',
                    },
                }}
            />
        </SimpleModal>
    );
}
